<template>
	<div class="responses">
		<ul>
			<li>List completed questionnaires</li>
		</ul>
		<h3>backend</h3>
		<ul>
			<li>when questionnaire is submitted or migrated, add a provider event with type questionnaire that has a copy of the questionnaire content</li>
		</ul>
	</div>
</template>


<script>
import ProviderView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'provider-responses',
	extends: ProviderView,

	data() {
		return {}
	},

	methods: {

	},

	computed: {

	},

	components: {

	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
